import { useEffect } from 'react'

const useWindowResize = ({ setIsDeviceMobile }: any) => {
  useEffect(() => {
    function handleResize() {
      // const isDesktop = window.innerWidth > 767 ? true : false
      // console.log(' isDesktop....', window.innerWidth > 767 ? true : false)
      setIsDeviceMobile(document.documentElement.clientWidth > 767 ? false : true)
      // setDeviceType({ isDesktop: window.innerWidth > 767 ? true : false })
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
}

export default useWindowResize
